module.exports = __webpack_public_path__ + "static/Action_2-61e20dfd7b5291bfafc47870acfda965.png";